/**
 * Recursively finds all image url's, section id's and section names in a nested JSON structure.
 *
 * @param {Object} data - The JSON object to search.
 * @returns {String[], String[], String[]} An array of image urls, an array of section id's, and an array of section names.
 */
function extractDataFromJson(data) {
  const images = [];
  const sections = [];
  const sectionNames = [];
  const stack = [data];

  while (stack.length) {
    const obj = stack.pop();
    if (obj && typeof obj === 'object') {
      for (const k in obj) {
        const v = obj[k];
        if (k === 'imageUrl') images.push(v);
        else if (k === 'secId') sections.push(v);
        else if (k === 'secName') sectionNames.push(v);
        if (v && typeof v === 'object') stack.push(v);
      }
    }
  }
  return { images: images.reverse(),
  sections: sections.reverse(),
  sectionNames: sectionNames.reverse(), };
}

export default extractDataFromJson;
